















































































































import _ from "lodash";
import assert from "assert";
import Spinner from "vue-simple-spinner";
import { VueGoodTable } from "vue-good-table";
import { Admin, Election, Vue } from "@/types.ts";

export default Vue.extend({
  name: "Admin",
  components: {
    Spinner,
    Vuetable: VueGoodTable,
  },
  computed: {
    administrators(): Array<Admin> | null {
      return this.$store.state.administrators;
    },
    columns() {
      const columns: Array<{
        label: string;
        field: string;
        type?: string;
        width?: string;
        sortable?: boolean;
      }> = [
        {
          label: "Nom",
          field: "name",
          width: "110px",
        },
        {
          label: "Courriel",
          field: "email",
        },
        {
          label: "Mot de passe",
          field: "password",
          sortable: false,
        },
        {
          label: "Super-utilisateur",
          field: "superuser",
          type: "boolean",
        },
        {
          label: "",
          field: "save",
          sortable: false,
          width: "60px",
        },
      ];
      return columns;
    },
    elections(): Array<Election> | null {
      const state = this.$store.state;
      assert(state.electionsTracker);
      const elections = state.elections;
      if (elections) return [...elections.values()];
      else return null;
    },
    electionsPreparing(): Array<Election> {
      const elections = this.elections;
      assert(elections);
      return _.filter(elections, e => !e.published);
    },
    electionsOpen(): Array<Election> {
      const elections = this.elections;
      assert(elections);
      return elections.filter(e => e.published && !e.tally);
    },
    electionsTallied(): Array<Election> {
      const elections = this.elections;
      assert(elections);
      return elections.filter(e => e.tally && !e.archived);
    },
    electionsArchived(): Array<Election> {
      const elections = this.elections;
      assert(elections);
      return elections.filter(e => e.archived);
    },
  },
  data(): { admins: Array<Admin> | null; creatingElection: boolean } {
    return {
      admins: null,
      creatingElection: false,
    };
  },
  methods: {
    async createAdmin(): Promise<void> {
      assert(this.admins);
      this.admins.push({
        name: "",
        email: "",
        password: "",
        superuser: false,
        dirty: true,
        fresh: true,
      });
    },
    async createElection(): Promise<void> {
      if (!this.creatingElection) {
        this.creatingElection = true;
        await this.$store.dispatch("createElection");
        this.creatingElection = false;
      }
    },
    dirty(admin: Admin): boolean {
      if (!admin.fresh) return admin.dirty || false;
      return admin.name !== "" && admin.email !== "" && admin.password !== "";
    },
    openElection(uuid: string): void {
      this.$router.push({ name: "Election", params: { uuid } });
    },
    async removeAdmin(admin: Admin): Promise<void> {
      await this.$store.dispatch("removeAdministrator", admin);
    },
    async save(admin: Admin): Promise<void> {
      await this.$store.dispatch("saveAdministrator", admin);
      admin.fresh = false;
      admin.dirty = false;
      admin.password = "";
    },
  },
  watch: {
    administrators: {
      handler(administrators: Array<Admin>) {
        if (administrators !== null)
          this.admins = _.map(administrators, a =>
            Object.assign({}, a, { dirty: false, fresh: false })
          );
      },
      immediate: true,
    },
  },
});
